import { useQuery } from "@tanstack/react-query";
import type { Supplier } from "../models/Supplier";
import { getSuppliers } from "../repositories/SuppliersRepository";

export const SUPPLIERS_QUERY_KEYS = {
	all: ["suppliers"] as const,
	list: () => ["suppliers", "list"] as const,
	byId: (id: number | null) => ["suppliers", "detail", id] as const,
};

export const useSuppliers = () => {
	const query = useQuery<Supplier[], Error>({
		queryKey: SUPPLIERS_QUERY_KEYS.list(),
		queryFn: () => getSuppliers(),
	});

	return {
		suppliers: query.data ?? [],
		isLoading: query.isLoading,
		error: query.error,
		refetch: query.refetch,
	};
};
